export const TaskStatus = {
  COMPLETED: "COMPLETED",
  PENDING: "PENDING",
  WAIT: "WAIT"
};
